export const machineKeys = {
  get: (userId?: string) => ["machine", userId] as const,
  listAvailable: () => ["availableMachines"] as const,
};
